<script>
	import { fade } from "svelte/transition";
	import ClassActionPhoneNumber from "../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../components/ClassActionEmailAddress.svelte";

	import PageSection from "../components/PageSection.svelte";

	import { pageNumber, model } from "../stores";
	import { projectSettings } from "../config";

	pageNumber.update((p) => 0);
</script>

<PageSection>
	<div class="row justify-content-md-center">
		<div class="col-8">
			<h1>There is a Problem</h1>

			<p>
				Thank you for trying to complete your registration form for the {projectSettings.classActionName}.
				Unfortunately there has been a problem.
			</p>
			<p>
				Please contact Shine Lawyers on <ClassActionPhoneNumber></ClassActionPhoneNumber>, or at
				<ClassActionEmailAddress></ClassActionEmailAddress>, and quote the registration number below and we can
				help you out.
			</p>
			<p>
				Your registration number is: {$model.RegistrationNumber}
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2,
	h3 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}
</style>
